module.exports = __webpack_public_path__ + "img/trial-white.2f0849de.svg";